import {
  contactInfoRows,
  contactLocation,
  contactSectionOverview,
  contactSocialLinks
} from "../../content/siteContent";
import { useSectionEntryStore } from "../../store/useSectionEntryStore";

const contactImage = "/images/characters/makara-contact.png";

function ContactIcon({ name }: { name: string }) {
  if (name === "mail") {
    return (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M3.75 6.75h16.5v10.5H3.75z" />
        <path d="m4.5 7.5 7.5 5.25 7.5-5.25" />
      </svg>
    );
  }

  if (name === "chat") {
    return (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M4.5 6.75h15v8.25h-8.25L7.5 18v-3H4.5z" />
      </svg>
    );
  }

  if (name === "pin") {
    return (
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M12 20.25s6-5.4 6-10.2a6 6 0 0 0-12 0c0 4.8 6 10.2 6 10.2Z" />
        <path d="M12 12.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z" />
      </svg>
    );
  }

  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M12 20.25a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5Z" />
      <path d="M12 7.5v5.25l3.5 2" />
    </svg>
  );
}

export function ContactSection() {
  const phase = useSectionEntryStore((state) => state.sections.contact.phase);

  return (
    <section className="experience-section experience-section--contact" data-entry-phase={phase}>
      <div className="contact-page">
        <div aria-hidden="true" className="contact-page__backdropText">
          Contact
        </div>

        <div className="contact-page__copy">
          <p className="contact-page__eyebrow">{contactSectionOverview.eyebrow}</p>
          <h2 className="contact-page__title">{contactSectionOverview.title}</h2>
          <p className="contact-page__intro">{contactSectionOverview.intro}</p>

          <div className="contact-page__location">
            <p>{contactLocation.label}</p>
          </div>

          <div className="contact-page__socials" aria-label="Follow 7 Stones">
            <p>Follow us</p>
            <div>
              {contactSocialLinks.map((link) => (
                <a href={link.href} key={link.label} rel="noreferrer" target={link.external ? "_blank" : undefined}>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="contact-page__visual" aria-hidden="true">
          <img alt="" className="contact-page__character" decoding="async" src={contactImage} />
        </div>

        <div className="contact-page__details" aria-label="Contact details">
          {contactInfoRows.map((row) => {
            const rowContent = (
              <>
                <span className="contact-page__detailIcon">
                  <ContactIcon name={row.icon} />
                </span>
                <span className="contact-page__detailCopy">
                  <strong>{row.label}</strong>
                  <span>{row.value}</span>
                </span>
              </>
            );

            return row.href ? (
              <a className="contact-page__detailRow" href={row.href} key={row.label}>
                {rowContent}
              </a>
            ) : (
              <div className="contact-page__detailRow" key={row.label}>
                {rowContent}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
